import * as React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { LocalizedLink } from "@/components/LocalizedLink";
import { useI18n } from "@/i18n";

const copy = {
  en: {
    title: "Page Not Found | Aureum VII Trading",
    description: "The page you are looking for could not be found. Browse our smart toilets or contact our Marbella team instead.",
    h1: "404 — Page not found",
    body: "The page you are looking for does not exist or may have moved.",
    home: "Back to home",
    products: "Browse smart toilets",
    contact: "Contact us",
  },
  es: {
    title: "Página no encontrada | Aureum VII Trading",
    description: "La página que busca no se ha encontrado. Explore nuestros inodoros inteligentes o contacte con nuestro equipo en Marbella.",
    h1: "404 — Página no encontrada",
    body: "La página que busca no existe o puede haber cambiado de dirección.",
    home: "Volver al inicio",
    products: "Ver inodoros inteligentes",
    contact: "Contacto",
  },
};

const NotFound = () => {
  const location = useLocation();
  const { language, isRTL } = useI18n();
  const c = language === "es" ? copy.es : copy.en;

  React.useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <html lang={language} dir={isRTL ? "rtl" : "ltr"} />
        <title>{c.title}</title>
        <meta name="description" content={c.description} />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center px-4">
          <h1 className="text-4xl font-bold mb-4 text-primary">{c.h1}</h1>
          <p className="text-xl text-muted-foreground mb-8">{c.body}</p>
          <nav className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <LocalizedLink to="/" className="text-accent hover:text-accent/80 underline font-semibold min-h-[44px] inline-flex items-center">
              {c.home}
            </LocalizedLink>
            <LocalizedLink to="/smart-toilets" className="text-accent hover:text-accent/80 underline font-semibold min-h-[44px] inline-flex items-center">
              {c.products}
            </LocalizedLink>
            <LocalizedLink to="/contact" className="text-accent hover:text-accent/80 underline font-semibold min-h-[44px] inline-flex items-center">
              {c.contact}
            </LocalizedLink>
          </nav>
        </div>
      </div>
    </>
  );
};

export default NotFound;
